import React, { useState, useEffect } from 'react';
import { get, filter, head, map, isEmpty } from 'lodash';
import { string, bool, func, array } from 'prop-types';
import { FormikSelect, Loading, FormSelect } from '../../common';
import { GetSalesChannels } from '../../graphql';

const FormikInputSalesChannel = ({
    fromResume,
    allSalesChannels,
    optionValueProp = 'id',
    native,
    value,
    onChange,
    multiple,
    allSelected,
    defaultValue,
    aditionalOptions,
    salesChannel,
    onCompleted,
    customizeOptions,
    ...props
}) => {
    const initialSalesChannelValue = isEmpty(salesChannel) ? [] : {
        value: get(salesChannel, 'id'),
        label: get(salesChannel, 'name'),
        kind: get(salesChannel, 'kind')
    };

    const [internalValue, setInternalValue] = useState(initialSalesChannelValue);

    const filterSalesChannelByKind = (salesChannel) => {
        if (fromResume) return filter(salesChannel, (saleChannel) => get(saleChannel, 'kind') === 'SPID35');
        return salesChannel;
    };

    const [count, setCount] = useState(0);
    const [internalData, setInternalData] = useState({});
    // const [internalValue, setInternalValue] = useState((isEmpty(defaultValue) || !defaultValue) ? value : defaultValue);

    useEffect(() => {
        onCompleted({ value: internalValue, data: internalData });
    }, [internalData]);

    return (
        <GetSalesChannels allSalesChannels={allSalesChannels}>
            {({ data, loading }) => {
                const option = ({ name, store, ...item }) => ({ ...item, value: get(item, optionValueProp), label: `${store} - ${name}` });
                const options = map(filterSalesChannelByKind(data), option);

                if (!loading && count === 0) {
                    setInternalData(data);
                    setCount(count + 1);
                }

                return (
                    <Loading loading={loading}>
                        { native ? (
                            <FormSelect
                                {...props}
                                onChange={({ value }) => {
                                    onChange({ value, data: head(filter(data, ({ id }) => get(value, 'value') === id)) });
                                    setInternalValue(value);
                                }}
                                showArrow
                                mode='multiple'
                                optionFilterProp='name'
                                options={customizeOptions([...options, ...aditionalOptions])}
                                value={internalValue}
                                allSelected={allSelected}
                                multiple={multiple}
                                defaultValue={defaultValue}
                            />
                        ) : (
                            <FormikSelect
                                {...props}
                                onChange={onChange}
                                showArrow
                                mode='multiple'
                                optionFilterProp='name'
                                options={options}
                                multiple={multiple}
                                allSelected={allSelected}
                            />
                        )}
                    </Loading>
                );
            }}
        </GetSalesChannels>
    );
};

FormikInputSalesChannel.defaultProps = {
    disabled: false,
    allSalesChannels: false,
    optionValueProp: 'id',
    aditionalOptions: [],
    onChange: () => {},
    onCompleted: () => {},
    customizeOptions: options => options
};

FormikInputSalesChannel.propTypes = {
    disabled: bool,
    allSalesChannels: bool,
    optionValueProp: string,
    onChange: func,
    native: bool,
    value: string,
    multiple: bool,
    allSelected: bool,
    defaultValue: string,
    aditionalOptions: array,
    salesChannel: string,
    fromResume: bool,
    onCompleted: func,
    customizeOptions: func
};

export default FormikInputSalesChannel;
